/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './appointment-history.reducer';

export const AppointmentHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const appointmentHistoryEntity = useAppSelector(state => state.appointmentHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="appointmentHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.appointmentHistory.detail.title">AppointmentHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.appointmentHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{appointmentHistoryEntity.id}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.appointmentHistory.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{appointmentHistoryEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.appointmentHistory.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{appointmentHistoryEntity.createdBy}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.appointmentHistory.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{appointmentHistoryEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.appointmentHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{appointmentHistoryEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.appointmentHistory.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{appointmentHistoryEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.appointmentHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{appointmentHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.appointmentHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{appointmentHistoryEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.appointmentHistory.appointment">Appointment</Translate>
          </dt>
          <dd>{appointmentHistoryEntity.appointment ? appointmentHistoryEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.appointmentHistory.status">Status</Translate>
          </dt>
          <dd>{appointmentHistoryEntity.status ? appointmentHistoryEntity.status.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/appointment-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/appointment-history/${appointmentHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AppointmentHistoryDetail;
